









































import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import AppTableDate from '@/components/AppTableDate.vue'
import { Account } from '@/modules/Account/interfaces/account'
import { dateToDisplay } from '@/utils/dateTime'
import { showErrors } from '@/utils/snack'
import { Claim } from '@/modules/Policy/interfaces/claim'
import { getClaimsOfAccount } from '@/modules/Policy/gql/claim.gql'

@Component({
  components: {
    AppTableDate
  }
})
export default class ClaimList extends Vue {
  @Prop({ type: Object as () => Account }) readonly account!: Account;

  dateToDisplay = dateToDisplay;

  claims: Claim[] = [];

  tableColumn = [
    {
      field: 'id',
      title: 'ID',
      width: 60
    },
    {
      field: 'policy.policyName',
      title: 'Policy Name',
      slots: { default: 'policyName' }
    },
    {
      field: 'totalAmount',
      title: 'Total Amount'
    },
    {
      field: 'claimDate',
      title: 'Claim Date',
      slots: { default: 'claimDate' }
    },
    {
      field: 'note',
      title: 'Note',
      slots: { default: 'note' },
      width: 130
    },
    {
      field: 'createdAt',
      title: 'Create Date',
      slots: { default: 'createdAt' }
    },
    {
      field: 'updatedAt',
      title: 'Update Date',
      slots: { default: 'updatedAt' }
    },
    {
      field: 'createdBy.username',
      title: 'Creator'
    },
    {
      field: 'lastModifiedBy.username',
      title: 'Last ModifiedBy'
    }
  ];

  loading = false;

  claimDialog = {
    show: false,
    title: 'Create Claim',
    disable: false
  };

  mounted () {
    this.getClaims()
  }

  // 获取claim list
  async getClaims () {
    this.loading = true
    try {
      const result = await this.$apollo.query({
        query: getClaimsOfAccount,
        variables: {
          accountId: +this.account.id
        }
      })
      this.claims = result.data.getClaimsOfAccount
      this.loading = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  // 跳转
  routeToDetail (item: any) {
    this.$router.push({
      name: 'PolicyDetailClaim',
      params: {
        id: item.policy.id
      }
    })
  }
}
